<div class="relative flex flex-col pl-6">
  @for (
    step of steps$ | async;
    track step.workflowId + ':' + step.nodeId;
    let isLast = $last
  ) {
    <div class="relative flex items-start mb-6 last:mb-0">
      <!-- Vertical Line -->
      <div
        class="absolute left-[11px] top-[28px] w-0.5 h-[50px] -translate-x-1/2"
        [ngClass]="{
          'bg-(--x-color-green)': step.status === 'submitted',
          'bg-(--x-color-yellow)': step.status === 'submitted-invalid',
          'bg-(--x-color-azure)': step.status === 'in-progress',
          'bg-(--x-workflow-text2)': step.status === 'not-started',
          hidden: step.isLast || isLast,
        }"
      ></div>

      <!-- Node Content -->
      <a
        [routerLink]="
          step.isLast
            ? [$baseRoute(), 'workflows', 'final']
            : [
                $baseRoute(),
                'workflows',
                step.workflowId,
                step.nodeId,
                step.formId,
              ]
        "
        class="flex items-start gap-4 w-full h-[60px] cursor-pointer"
      >
        <ng-container
          *ngTemplateOutlet="stepContent; context: { $implicit: step }"
        />
      </a>
    </div>
  }
</div>

<!-- Shared step content template -->
<ng-template #stepContent let-step>
  <!-- Circle -->
  <div
    class="relative flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center z-[1]"
    [ngClass]="{
      'bg-(--x-color-green) border-2 border-(--x-color-green)':
        step.status === 'submitted',
      'bg-(--x-color-yellow) border-2 border-(--x-color-yellow)':
        step.status === 'submitted-invalid',
      'bg-(--x-color-azure) border-2 border-(--x-color-azure)':
        step.status === 'in-progress',
      'bg-transparent border-2 border-(--x-workflow-text2)':
        step.status === 'not-started',
    }"
  >
    @switch (step.status) {
      @case ('submitted') {
        <span class="block text-white text-sm font-bold">✓</span>
      }
      @case ('submitted-invalid') {
        <span class="block text-white text-sm font-bold">!</span>
      }
    }
  </div>

  <!-- Text Content -->
  <div class="flex-1">
    <div
      class="x-font-body-4-bold text-(--x-dark-main) mb-1"
      [ngClass]="{ relative: !step.isLast }"
    >
      @if (step.isLast) {
        <span>{{ 'workflows.complete_request_step' | translate }}</span>
      } @else {
        <span>{{ step.stageLabel }}. {{ step.task }}</span>
        @let pendingCount = step.pendingCount$ | async;
        @if (typeof pendingCount === 'number' && pendingCount > 0) {
          <span class="ml-1 absolute">
            <tui-loader class="opacity-50" [size]="'s'"></tui-loader>
          </span>
        }
      }
    </div>
    @if (step.date) {
      <div class="x-font-body-5 text-(--x-dark-secondary)">
        {{ step.date }}
      </div>
    }
  </div>
</ng-template>
